<template>
<ItpPage
  no-primary-button
  :closeButtonText="'Close'|gettext"
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="RentalService"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :name="formName"
      :schema="oid == null ? 'CreateRentalService' : 'UpdateRentalService'"
      :id="formId"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <DIV
        v-if="assignToRental"
      >
        <ItpFormGroup
          labelColsMd="3"
          contentColsMd="9"
          :labelAlign="labelAlign"
          name="rental"
          :label="'Rental'|pgettext('RentalService')"
          required
        >
          <UcRentalSelector
            name="rental"
            :item="item"
            path="rental"
            :readonly="isReadOnly || preventEditRental"
            required
          >
          </UcRentalSelector>
        </ItpFormGroup>
        <hr>
        </hr>
      </DIV>
      <ItpFormGroup
        name="meter"
        :label="'Meter'|pgettext('RentalService')"
        labelColsMd="3"
        contentColsMd="9"
        :labelAlign="labelAlign"
        required
      >
        <ItpFormSelect2
          name="meter"
          v-model="item.meter"
          :dataSource="b_2070266589801014_dataSource"
          :initialOptions="item.meter ? [item.meter] : []"
          valueField="id"
          textField="serial_number"
          bind-object
          use-option-template-for-selected-option
          optionTemplate="<UcSuggestMeterOption :option=&quot;option&quot;></UcSuggestMeterOption>"
          required
          :readonly="preventEditMeter || isReadOnly"
          @optionSelected="evh_2070266589801014_optionSelected($event, {})"
        >
        </ItpFormSelect2>
      </ItpFormGroup>
      <ItpFormGroup
        name="meter_factor"
        :label="'Meter factor'|pgettext('RentalService')"
        labelColsMd="3"
        contentColsMd="4"
        :labelAlign="labelAlign"
        required
      >
        <ItpFormInput
          type="number"
          name="meter_factor"
          v-model="item.meter_factor"
          :readonly="isReadOnly"
          required
        >
        </ItpFormInput>
      </ItpFormGroup>
      <ItpFormGroup
        name="service"
        :label="'Service'|pgettext('RentalService')"
        labelColsMd="3"
        contentColsMd="9"
        :labelAlign="labelAlign"
        required
      >
        <ItpFormSelect2
          name="service"
          v-model="item.service"
          :dataSource="b_5074589820235598_dataSource"
          bind-object
          valueField="id"
          textField="name"
          :readonly="isReadOnly"
          required
          @optionSelected="evh_5074589820235598_optionSelected($event, {})"
        >
        </ItpFormSelect2>
      </ItpFormGroup>
      <ItpFormGroup
        name="name"
        :label="'Name'|pgettext('RentalService')"
        labelColsMd="3"
        contentColsMd="9"
        :labelAlign="labelAlign"
        :helpTooltip="'This text will appear on the invice line.'|pgettext('RentalService|Tooltip')"
        required
      >
        <ItpFormInput
          name="name"
          v-model="item.name"
          required
          :readonly="isReadOnly"
        >
        </ItpFormInput>
      </ItpFormGroup>
      <ItpFormGroup
        name="name"
        :label="'Name(s)'|pgettext('RentalService')"
        labelColsMd="3"
        contentColsMd="9"
        :labelAlign="labelAlign"
        :helpTooltip="'This text will appear on the invice line.'|pgettext('RentalService|Tooltip')"
        required
      >
        <UCContractServiceItemNameEditor
          v-model="item.invoice_item_name"
          :readonly="isReadOnly"
        >
        </UCContractServiceItemNameEditor>
      </ItpFormGroup>
      <ItpFormGroup
        name="invoice_notes"
        :label="'Invoice notes'|pgettext('RentalService')"
        labelColsMd="3"
        contentColsMd="9"
        :labelAlign="labelAlign"
        :helpTooltip="'Note to display on the invoice line.'|pgettext('RentalService|Tooltip')"
      >
        <ItpFormTextarea
          name="fee_notes"
          v-model="item.invoice_notes"
          :readonly="isReadOnly"
        >
        </ItpFormTextarea>
      </ItpFormGroup>
      <ItpFormGroup
        name="tariff_code"
        :label="'Tariff'|pgettext('RentalService')"
        labelColsMd="3"
        contentColsMd="9"
        :labelAlign="labelAlign"
        v-if="tariffs && tariffs.length"
      >
        <ItpFormSelect2
          name="tariff_code"
          v-model="item.tariff_code"
          :options="tariffs"
          clearable
          valueField="code"
          textField="code,name"
        >
        </ItpFormSelect2>
      </ItpFormGroup>
      <ItpFormGroup
        name="billing_unit"
        :label="'Billing unit'|pgettext('RentalService')"
        labelColsMd="3"
        contentColsMd="3"
        :labelAlign="labelAlign"
        required
      >
        <ItpFormSelect2
          name="billing_unit"
          v-model="item.billing_unit"
          :options="units"
          valueField="symbol"
          textField="symbol"
          :readonly="isReadOnly"
          required
        >
        </ItpFormSelect2>
      </ItpFormGroup>
      <ItpFormGroup
        name="intermediated_service"
        :label="'Intermediated service'|pgettext('RentalService')"
        labelColsMd="3"
        contentColsMd="9"
        :labelAlign="labelAlign"
      >
        <ItpFormCheckbox
          name="intermediated_service"
          inline
          v-model="item.intermediated_service"
          :readonly="isReadOnly"
        >
        </ItpFormCheckbox>
      </ItpFormGroup>
      <ItpFormGroup
        name="non_billable"
        :label="'Non billable'|pgettext('RentalService')"
        labelColsMd="3"
        contentColsMd="9"
        :labelAlign="labelAlign"
      >
        <ItpFormCheckbox
          name="non_billable"
          inline
          v-model="item.non_billable"
          :readonly="isReadOnly"
        >
        </ItpFormCheckbox>
      </ItpFormGroup>
      <hr>
      </hr>
      <ItpFormGroup
        name="valid_from"
        :label="'Validity'|pgettext('RentalService')"
        labelColsMd="3"
        contentColsMd="5"
        :labelAlign="labelAlign"
        contentClass="form-row"
      >
        <div
          class="col"
        >
          <ItpFormDatetime
            type="date"
            name="valid_from"
            :placeholder="'Valid from'|pgettext('InputPlaceholder')"
            v-model="item.valid_from"
            :readonly="isReadOnly"
          >
          </ItpFormDatetime>
        </div>
        <div
          class="col"
        >
          <ItpFormDatetime
            type="date"
            name="valid_to"
            :placeholder="'Valid to'|pgettext('InputPlaceholder')"
            v-model="item.valid_to"
            :readonly="isReadOnly"
          >
          </ItpFormDatetime>
        </div>
      </ItpFormGroup>
      <ItpFormGroup
        name="inactive"
        :label="'Inactive'|pgettext('RentalService')"
        labelColsMd="3"
        contentColsMd="9"
        :labelAlign="labelAlign"
      >
        <ItpFormCheckbox
          name="inactive"
          inline
          v-model="item.inactive"
          :readonly="isReadOnly"
        >
        </ItpFormCheckbox>
      </ItpFormGroup>
      <hr>
      </hr>
      <ItpFormGroup
        name="notes"
        :label="'Notes'|pgettext('RentalService')"
        labelColsMd="3"
        contentColsMd="9"
        :labelAlign="labelAlign"
      >
        <ItpFormTextarea
          name="note"
          v-model="item.notes"
          :readonly="isReadOnly"
        >
        </ItpFormTextarea>
      </ItpFormGroup>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpBox
      class="mr-auto"
      v-if="oid && !item.locked"
    >
      <BtnDeleteResource
        :resource="item"
        :disabled="actions.submit.isRunning"
        @success="evh_2140198529698299_success($event, {})"
      >
      </BtnDeleteResource>
      <BtnLockResource
        :resource="item"
        :disabled="actions.submit.isRunning"
        class="ml-3"
        @success="evh_2434514588044777_success($event, {})"
      >
      </BtnLockResource>
    </ItpBox>
    <ItpButton
      :text="'Save'|pgettext('ModalButton')"
      type="submit"
      :form="formId"
      variant="primary"
      icon="fa-save"
      :spinning="actions.submit.isRunning"
      :disabled="!forms[formName] || !forms[formName].submittable"
      v-if="!item.locked"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|pgettext('ModalButton')"
      variant="default"
      :disabled="actions.submit.isRunning"
      @click.prevent.stop="evh_2186679009640457_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class RentalService extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
    default: null,
  })
  oid!: string;

  @Watch('oid')
  onOid(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("oid")
  }

  @Prop({
    type: Object,
    default: null,
  })
  rental!: object;

  @Watch('rental')
  onRental(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("rental")
  }

  @Prop({
    type: Object,
    default: null,
  })
  meter!: object;

  @Watch('meter')
  onMeter(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("meter")
  }

  @Prop({
    type: Boolean,
    default: false,
  })
  preventEditRental!: boolean;

  @Watch('preventEditRental')
  onPrevent_edit_rental(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("preventEditRental")
  }

  @Prop({
    type: Boolean,
    default: false,
  })
  preventEditMeter!: boolean;

  @Watch('preventEditMeter')
  onPrevent_edit_meter(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("preventEditMeter")
  }

  @Prop({
    type: Boolean,
    default: false,
  })
  assignToRental!: boolean;

  @Watch('assignToRental')
  onAssign_to_rental(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("assignToRental")
  }

  @Prop({
    type: Boolean,
    default: false,
  })
  assignToMeter!: boolean;

  @Watch('assignToMeter')
  onAssign_to_meter(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("assignToMeter")
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  item!: any;

  async $$load_item() {
    return this.oid
      ? this.$fn.fetch('read_rental_service', { parameters: { id: this.oid } })
      : this.$fn.fetch('get_rental_service_defaults', {
        parameters: {
          meter_id: this.meter ? this.meter.id : null,
          rental_id: this.rental ? this.rental.id : null,
        }
      })
  }

  units!: any;

  async $$load_units() {
    return this.$fn.fetch('list_unit').then(d => _.orderBy(d, [p => p.symbol.toLowerCase()]))
  }

  formName!: any;
  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  labelAlign!: any;
  isReadOnly!: any;

  async $$load_isReadOnly() {
    return this.item.locked
  }

  tariffs!: any;

  async $$load_tariffs() {
    return this.$app.repo.get('list_object_by_type', { parameters: { object_type: 'tariff' } })
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_2070266589801014_dataSource!: any;
  b_5074589820235598_dataSource!: any;
  dataMembers = ['item', 'units', 'formName', 'formId', 'labelAlign', 'isReadOnly', 'tariffs', 'ux', 'b_7315092382398562_modalBindings', 'b_2070266589801014_dataSource', 'b_5074589820235598_dataSource'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        item: null,
        units: null,
        formName: "rentalService",
        formId: null,
        labelAlign: "right",
        isReadOnly: null,
        tariffs: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          noPrimaryButton: true,
          closeButtonText: this.$fn.gettext("Close"),
          size: "lg",
        }
        ,
        b_2070266589801014_dataSource: {
          name: "suggest_meter",
        }
        ,
        b_5074589820235598_dataSource: {
          name: "suggest_product",
          parameters: {
            product_types: "service",
          }
          ,
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.oid ? this.$fn.gettext('Edit Rental Service') : this.$fn.gettext('Add Rental Service'),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_9750_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_9750, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeModal_9756_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1040167445267876_closeModal_9756, alias=undefined
    return {
      name: this.modalName,
      result: {
        ok: true,
        value: $event.data.response.data,
      }
      ,
    }
  }

  async act_1040167445267876_request_9754_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1040167445267876_request_9754, alias=submit
    return {
      operation: this.item.id ? 'update_rental_service' : 'create_rental_service',
      data: _.extend(this.item, { rental_id: this.item.rental.id }),
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async act_2070266589801014_script_9760_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_2070266589801014_script_9760, alias=undefined
    _.extend(this.item, $event.data.response.data)
  }

  async act_2070266589801014_script_9760_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_2070266589801014_script_9760, alias=undefined
    return {
      value: () => this.act_2070266589801014_script_9760_getActionArgs_value($event),
    }
  }

  async act_2070266589801014_request_9758_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_2070266589801014_request_9758, alias=getDefaultsOnMeterSelected
    return {
      operation: "get_rental_service_defaults",
      data: {
        rental_id: this.rental ? this.rental.id : this.item.rental_id,
        meter_id: this.item.meter.id,
      }
      ,
    }
  }

  async evh_2070266589801014_optionSelected(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2070266589801014_optionSelected.executeFromDOM(this, event, scope);
  }

  async act_5074589820235598_setData_9762_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_5074589820235598_setData_9762, alias=undefined
    return {
      path: "item.service_id",
      value: this.item.service.id,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_5074589820235598_setData_9764_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_5074589820235598_setData_9764, alias=undefined
    return {
      path: "item.name",
      value: $event.data.option.name,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_5074589820235598_optionSelected(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5074589820235598_optionSelected.executeFromDOM(this, event, scope);
  }

  async act_2140198529698299_closeModal_9766_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_2140198529698299_closeModal_9766, alias=undefined
    return {
      result: {
        ok: true,
      }
      ,
    }
  }

  async evh_2140198529698299_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2140198529698299_success.executeFromDOM(this, event, scope);
  }

  async act_2434514588044777_closeModal_9768_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_2434514588044777_closeModal_9768, alias=undefined
    return {
      result: {
        ok: true,
      }
      ,
    }
  }

  async evh_2434514588044777_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2434514588044777_success.executeFromDOM(this, event, scope);
  }

  async act_2186679009640457_closeModal_9770_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_2186679009640457_closeModal_9770, alias=undefined
    return {
      name: this.modalName,
      result: {
        cancel: true,
      }
      ,
    }
  }

  async evh_2186679009640457_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2186679009640457_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_9750: actions.CloseModalAction;
    evh_7315092382398562_close_9749: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_9752: actions.CloseComponentAction;
    evh_2248226175642056_close_9751: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_closeModal_9756: actions.CloseModalAction;
    evh_1040167445267876_success_9755: actions.EventHandlerImpl;
    act_1040167445267876_request_9754: actions.RequestAction;
    evh_1040167445267876_submit_9753: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_2070266589801014_script_9760: actions.ScriptAction;
    evh_2070266589801014_success_9759: actions.EventHandlerImpl;
    act_2070266589801014_request_9758: actions.RequestAction;
    evh_2070266589801014_optionSelected_9757: actions.EventHandlerImpl;
    evh_2070266589801014_optionSelected: actions.EventHandlerGroup;
    act_5074589820235598_setData_9762: actions.SetDataAction;
    evh_5074589820235598_optionSelected_9761: actions.EventHandlerImpl;
    act_5074589820235598_setData_9764: actions.SetDataAction;
    evh_5074589820235598_optionSelected_9763: actions.EventHandlerImpl;
    evh_5074589820235598_optionSelected: actions.EventHandlerGroup;
    act_2140198529698299_closeModal_9766: actions.CloseModalAction;
    evh_2140198529698299_success_9765: actions.EventHandlerImpl;
    evh_2140198529698299_success: actions.EventHandlerGroup;
    act_2434514588044777_closeModal_9768: actions.CloseModalAction;
    evh_2434514588044777_success_9767: actions.EventHandlerImpl;
    evh_2434514588044777_success: actions.EventHandlerGroup;
    act_2186679009640457_closeModal_9770: actions.CloseModalAction;
    evh_2186679009640457_clickPreventStop_9769: actions.EventHandlerImpl;
    evh_2186679009640457_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_9750 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_9750_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_9749 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_9750,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_9749],
      }
    );
    const act_2248226175642056_closeComponent_9752 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_9751 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_9752,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_9751],
      }
    );
    const act_1040167445267876_closeModal_9756 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1040167445267876_closeModal_9756_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_9755 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeModal_9756,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_1040167445267876_request_9754 = new actions.RequestAction(
      {
        actionArgs: this.act_1040167445267876_request_9754_getActionArgs,
        displayName: "submit",
        events: [evh_1040167445267876_success_9755],
      }
    );
    const evh_1040167445267876_submit_9753 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_request_9754,
        event: "submit",
        displayName: "submit",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_9753],
      }
    );
    const act_2070266589801014_script_9760 = new actions.ScriptAction(
      {
        actionArgs: this.act_2070266589801014_script_9760_getActionArgs,
        events: [],
      }
    );
    const evh_2070266589801014_success_9759 = new actions.EventHandlerImpl(
      {
        action: act_2070266589801014_script_9760,
        event: "success",
        displayName: "script",
      }
    );
    const act_2070266589801014_request_9758 = new actions.RequestAction(
      {
        actionArgs: this.act_2070266589801014_request_9758_getActionArgs,
        displayName: "getDefaultsOnMeterSelected",
        events: [evh_2070266589801014_success_9759],
      }
    );
    const evh_2070266589801014_optionSelected_9757 = new actions.EventHandlerImpl(
      {
        action: act_2070266589801014_request_9758,
        event: "optionSelected",
        displayName: "getDefaultsOnMeterSelected",
      }
    );
    const evh_2070266589801014_optionSelected = new actions.EventHandlerGroup(
      {
        handlers: [evh_2070266589801014_optionSelected_9757],
      }
    );
    const act_5074589820235598_setData_9762 = new actions.SetDataAction(
      {
        actionArgs: this.act_5074589820235598_setData_9762_getActionArgs,
        events: [],
      }
    );
    const evh_5074589820235598_optionSelected_9761 = new actions.EventHandlerImpl(
      {
        action: act_5074589820235598_setData_9762,
        event: "optionSelected",
        displayName: "setData",
      }
    );
    const act_5074589820235598_setData_9764 = new actions.SetDataAction(
      {
        actionArgs: this.act_5074589820235598_setData_9764_getActionArgs,
        events: [],
      }
    );
    const evh_5074589820235598_optionSelected_9763 = new actions.EventHandlerImpl(
      {
        action: act_5074589820235598_setData_9764,
        event: "optionSelected",
        displayName: "setData",
      }
    );
    const evh_5074589820235598_optionSelected = new actions.EventHandlerGroup(
      {
        handlers: [evh_5074589820235598_optionSelected_9761, evh_5074589820235598_optionSelected_9763],
      }
    );
    const act_2140198529698299_closeModal_9766 = new actions.CloseModalAction(
      {
        actionArgs: this.act_2140198529698299_closeModal_9766_getActionArgs,
        events: [],
      }
    );
    const evh_2140198529698299_success_9765 = new actions.EventHandlerImpl(
      {
        action: act_2140198529698299_closeModal_9766,
        event: "success",
        displayName: "closeModal",
      }
    );
    const evh_2140198529698299_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_2140198529698299_success_9765],
      }
    );
    const act_2434514588044777_closeModal_9768 = new actions.CloseModalAction(
      {
        actionArgs: this.act_2434514588044777_closeModal_9768_getActionArgs,
        events: [],
      }
    );
    const evh_2434514588044777_success_9767 = new actions.EventHandlerImpl(
      {
        action: act_2434514588044777_closeModal_9768,
        event: "success",
        displayName: "closeModal",
      }
    );
    const evh_2434514588044777_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_2434514588044777_success_9767],
      }
    );
    const act_2186679009640457_closeModal_9770 = new actions.CloseModalAction(
      {
        actionArgs: this.act_2186679009640457_closeModal_9770_getActionArgs,
        events: [],
      }
    );
    const evh_2186679009640457_clickPreventStop_9769 = new actions.EventHandlerImpl(
      {
        action: act_2186679009640457_closeModal_9770,
        event: "click.prevent.stop",
        displayName: "closeModal",
      }
    );
    const evh_2186679009640457_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_2186679009640457_clickPreventStop_9769],
      }
    );
    return {
      act_7315092382398562_closeModal_9750,
      evh_7315092382398562_close_9749,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_9752,
      evh_2248226175642056_close_9751,
      evh_2248226175642056_close,
      act_1040167445267876_closeModal_9756,
      evh_1040167445267876_success_9755,
      act_1040167445267876_request_9754,
      evh_1040167445267876_submit_9753,
      evh_1040167445267876_submit,
      act_2070266589801014_script_9760,
      evh_2070266589801014_success_9759,
      act_2070266589801014_request_9758,
      evh_2070266589801014_optionSelected_9757,
      evh_2070266589801014_optionSelected,
      act_5074589820235598_setData_9762,
      evh_5074589820235598_optionSelected_9761,
      act_5074589820235598_setData_9764,
      evh_5074589820235598_optionSelected_9763,
      evh_5074589820235598_optionSelected,
      act_2140198529698299_closeModal_9766,
      evh_2140198529698299_success_9765,
      evh_2140198529698299_success,
      act_2434514588044777_closeModal_9768,
      evh_2434514588044777_success_9767,
      evh_2434514588044777_success,
      act_2186679009640457_closeModal_9770,
      evh_2186679009640457_clickPreventStop_9769,
      evh_2186679009640457_clickPreventStop,
      submit: act_1040167445267876_request_9754,
      getDefaultsOnMeterSelected: act_2070266589801014_request_9758,
    }
  }
}

Vue.component("RentalService", RentalService);

</script>